import React, { useEffect } from "react";
import Header from "../common/Header";
import hero_top_bg_mobile from "../../assets/images/png/hero_top_bg_mobile.png";
import hero_top_bg from "../../assets/images/png/hero_top_bg.png";
import hero_piller_img_mobile from "../../assets/images/png/hero_piller_img_mobile.png";
import hero_piller_img from "../../assets/images/png/hero_piller_img.png";
import hero_flowers_mobile from "../../assets/images/png/hero_flowers_mobile.png";
import hero_temple from "../../assets/images/webp/hero_temple.webp";
import hero_temple2 from "../../assets/images/png/bg_home.png";
import bg from "../../assets/images/webp/bg_girnar.webp";

import Button from "../common/button/Button";
import { Link, useLocation } from "react-router-dom";
const Hero = () => {
  const { pathname } = useLocation();
  let location = useLocation();

  console.log(location.hash, "pathname")
  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById("register");
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth"
        });
      }
    }
    // Scroll to the specific section with the id "fromregister" when the component mounts

  }, []);
  return (
    <>
      <div className="hero_section text-white d-flex align-items-end align-items-lg-center justify-content-center ">
        <Header />
        {/*<img
          className={`w-100 position-absolute top-0 start-0 object-fit-cover hero_orange_bg d-sm-none ${pathname === "/"
            ? "hero_orange_bg"
            : "hero_orange_bg_two hero_orange_bg"
            }`}
          src={hero_top_bg_mobile}
          alt="hero_top_bg"
        />
        <img
          className="w-100 position-absolute top-0 start-0 object-fit-cover hero_orange_bg d-none d-sm-block"
          src={hero_top_bg}
          alt="hero_top_bg"
          />*/}
        <img
          className={`position-absolute w-100 hero_temple_img bottom-0 object-fit-cover object-position-center ${pathname === "/"
            ? "hero_temple_img_two hero_temple_img"
            : "hero_temple_img"
            }`}
          src={bg}
          alt="hero_temple"
        />
        {/*<img
          className="position-absolute end-0 hero_piller bottom-0 d-sm-none"
          src={hero_piller_img_mobile}
          alt="hero_piller_img"
        />
        <img
          className="position-absolute start-0 hero_piller bottom-0 d-sm-none"
          src={hero_piller_img_mobile}
          alt="hero_piller_img"
        />
        <img
          className="position-absolute end-0 hero_piller bottom-0 d-none d-sm-block"
          src={hero_piller_img}
          alt="hero_piller_img"
        />
        <img
          className="position-absolute start-0 hero_piller bottom-0 d-none d-sm-block"
          src={hero_piller_img}
          alt="hero_piller_img"
        />
        <img
          className="d-none d-sm-block position-absolute start-0 hero_flowers_chain_mobile d-sm-none w-100"
          src={hero_flowers_mobile}
          alt="hero_flowers"
          />*/}
        <div className="hero_content pt-3 pt-md-5 pt-sm-0">
          <div className="container container_modified text-center pt-1 pt-sm-0 mt-0 mt-xl-0 mt-lg-5 mt-md-5 ">
            {pathname === "/" ? (
              <>
                <h2 className="font-xl fw-bold mb-3">
                  <span className="font-lg common_heading_text text-uppercase transition_03 d-block text-light-yellow">
                  Meditation simplified for all !
                  </span>
                  <span className="text-uppercase ">
                  HARI OM TATSAT JAI GURU DATTA
                  </span>
                </h2>
                <p className="mx-auto font-sm fw-medium mb-3">
                  The Divine Maha Mantra "Hari Om Tatsat Jai Guru Datta" was bestowed by Sadguru Dattatreya to P.P. Maharshi Punitachariji on November 15. 1975. The Mantra is immensely powerful as having been blessed by all deities and Siddhas. Any spiritual seeker can achieve a state of meditation by simply chanting this Mantra for 15-20 mins and then sitting with the eyes closed. 
                </p>
                <Link to="/hari-om-tatsat-jai-guru-datta" className="d-flex justify-content-center">
                  <Button title="Learn More" />
                </Link>
              </>
            ) : (
              <>
                <h2 className="font-xl fw-bold mb-3">
                  <span className="font-md common_heading_text text-uppercase transition_03 d-block text-dark-yellow">
                    Trimurti Ashram
                  </span>
                   10-Day Retreat Course
                </h2>
                <p className="mx-auto font-sm fw-medium">
                  Offered by Trimurti Ashram in
                  Rishikesh is unequaled as to the depth of experience and the
                  fullness of understanding about Life, Self and purpose.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
